import PageLayout from "@/components/layout/PageLayout";
import Differentiators from "@/components/sections/Differentiators";

export default function ApproachPage() {
  return (
    <PageLayout testId="approach-page">
      <Differentiators />
    </PageLayout>
  );
}
